import React from "react";
import {EmailLog, OutputStatus} from "../types";
import {normalizeImagesByStation, stationNames} from "../utils/images";

type Props = {
    outputStatus: OutputStatus | null;
    outputError: string;
    radarThreshold: number;
    sensorsThreshold: number;
    mediaThreshold: number;
    getStatusColor: (value: number | null, threshold: number) => string;
    formatValue: (value: number | null) => string;
    openLinksPage: (title: string, links: string[]) => void;
    onOpenEmail: (email: EmailLog) => void;
};

export const SynopticPanel: React.FC<Props> = ({
    outputStatus,
    outputError,
    radarThreshold,
    sensorsThreshold,
    mediaThreshold,
    getStatusColor,
    formatValue,
    openLinksPage,
    onOpenEmail,
}) => {
    const imagesByStation = normalizeImagesByStation(outputStatus?.lista_path_immagini);
    const stations = stationNames(imagesByStation);

    return (
        <aside className="left-panel">
            <div className="panel-header">
                <h2>WeWair</h2>
                <div className="panel-subtitle">Rilevatore operativo</div>
            </div>

            <section className="synoptic-container">
                <h3>Sinottico</h3>
                {outputStatus ? (
                    <>
                        <div className="kv">
                            <div className="k">Timestamp</div>
                            <div className="v">{outputStatus.timestamp}</div>
                        </div>
                        <div className="synoptic-grid">
                            <div
                                className="status-box"
                                style={{
                                    backgroundColor: getStatusColor(outputStatus.stima_radar, radarThreshold),
                                }}
                            >
                                <div className="status-title">Radar</div>
                                <div className="status-value">{formatValue(outputStatus.stima_radar)}</div>
                            </div>
                            <div
                                className="status-box"
                                style={{
                                    backgroundColor: getStatusColor(outputStatus.stima_sensori, sensorsThreshold),
                                }}
                            >
                                <div className="status-title">Sensori</div>
                                <div className="status-value">{formatValue(outputStatus.stima_sensori)}</div>
                            </div>
                            <div
                                className="status-box"
                                style={{
                                    backgroundColor: getStatusColor(outputStatus.media_stima, mediaThreshold),
                                }}
                            >
                                <div className="status-title">Combinata</div>
                                <div className="status-value">{formatValue(outputStatus.media_stima)}</div>
                            </div>
                        </div>
                        <div className="kv">
                            <div className="k">CSV</div>
                            <div className="v mono">
                                {outputStatus.path_txt ? (
                                    <button
                                        className="link-button"
                                        onClick={() => openLinksPage("CSV (ultimo output)", [outputStatus.path_txt])}
                                    >
                                        Apri CSV
                                    </button>
                                ) : (
                                    "—"
                                )}
                            </div>
                        </div>
                        <div className="kv">
                            <div className="k">Immagini</div>
                            <div className="v mono">
                                {stations.length ? (
                                    <div className="station-links">
                                        {stations.map((s) => (
                                            <button
                                                key={s}
                                                className="link-button"
                                                onClick={() =>
                                                    openLinksPage(`Immagini ${s} (ultimo output)`, imagesByStation[s])
                                                }
                                            >
                                                {s} ({imagesByStation[s].length})
                                            </button>
                                        ))}
                                    </div>
                                ) : (
                                    "—"
                                )}
                            </div>
                        </div>
                        <div className="kv">
                            <div className="k">Email</div>
                            <div className="v mono">
                                {outputStatus.email ? (
                                    <button className="link-button" onClick={() => onOpenEmail(outputStatus.email!)}>
                                        Apri email
                                    </button>
                                ) : (
                                    "—"
                                )}
                            </div>
                        </div>
                    </>
                ) : (
                    <p className="muted">{outputError || "Nessun output disponibile al momento."}</p>
                )}
                <div style={{marginTop: "16px"}} />
            </section>
        </aside>
    );
};
